import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useBanners(env, client) {
  const [loadedBanners, setLoadedBanners] = useState(false);
  const [banners, setBanners] = useState(null);

  useEffect(() => {
    setLoadedBanners(false);
    if (!client) {
      setLoadedBanners(true);
      return () => [];
    }
    let ref = collection(db, "kiosk", env, "client", client, "banners");
    
    // onSnapshot = reactivo + offline + cache
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBanners(data);
      setLoadedBanners(true);
    });

    return () => unsub();
  }, [env, client]);

  return { loadedBanners, banners };
}